import { Box, Typography } from "@mui/material";

export const Footer = () => {
  return (
    <Box
      sx={{
        bottom: 0,
        left: 0,
        width: "100%",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: { xs: "center", sm: "space-between" },
        alignItems: "center",
        gap: { xs: 1.5, sm: 0 },
        px: { xs: 2, sm: "80px" },
        py: { xs: 2, sm: 0 },
        color: "white",
        mt: "auto",
        zIndex: 1000,
        textAlign: "center",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: "white",
          fontFamily: "Rethink Sans",
          fontSize: "0.875rem",
          lineHeight: "143%",
          letterSpacing: "0.17px",
        }}
      >
        © 2025 Lucro - All Rights Reserved
      </Typography>

      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <Typography
          variant="body2"
          onClick={() =>
            window.open(
              "https://morelucro.com/policies/privacy-policy/",
              "_blank"
            )
          }
          sx={{
            color: "white",
            fontFamily: "Rethink Sans",
            fontSize: "0.875rem",
            cursor: "pointer",
            textDecoration: "underline",
            "&:hover": { opacity: 0.8 },
          }}
        >
          Privacy Policy
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "white",
            fontFamily: "Rethink Sans",
            fontSize: "0.875rem",
          }}
        >
          -
        </Typography>

        <Typography
          variant="body2"
          onClick={() =>
            window.open(
              "https://morelucro.com/policies/terms-and-conditions/",
              "_blank"
            )
          }
          sx={{
            color: "white",
            fontFamily: "Rethink Sans",
            fontSize: "0.875rem",
            cursor: "pointer",
            textDecoration: "underline",
            "&:hover": { opacity: 0.8 },
          }}
        >
          Terms of Service
        </Typography>
      </Box>
    </Box>
  );
};
